import type { WebModule } from "../../core/modules";
import { AppelsPage } from "./routes/appels";
import { AppelPage } from "./routes/appel";
import { RepondeurPage } from "./routes/repondeur";
import { AppelsWidget } from "./components/home-widget";

// Répondeur IA PROTECTO : appels en direct et historique (tous), réglages de
// l'assistante (admin), widget d'accueil. La téléphonie et l'agent vivent
// dans des briques internes qui poussent les appels à l'API.
const appels: WebModule = {
  name: "x-appels",
  routes: [
    { path: "/appels", element: <AppelsPage /> },
    { path: "/appels/repondeur", element: <RepondeurPage />, adminOnly: true },
    { path: "/appels/:id", element: <AppelPage /> },
  ],
  nav: [
    {
      title: "Appels",
      // Juste après l'atelier : le téléphone, c'est aussi le quotidien.
      order: 20,
      items: [
        { to: "/appels", label: "Appels", icon: "phone", end: true },
        {
          to: "/appels/repondeur",
          label: "Répondeur IA",
          icon: "sparkles",
          end: true,
          adminOnly: true,
        },
      ],
    },
  ],
  homeWidgets: [{ id: "appels-today", element: <AppelsWidget /> }],
};

export default appels;
